import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MockupIndex from "@/pages/MockupIndex";
import MockupNotes from "@/pages/MockupNotes";
import Auditions from "@/pages/Auditions";
import Entry from "@/pages/participant/Entry";
import Consent from "@/pages/participant/Consent";
import Session from "@/pages/participant/Session";
import Fallback from "@/pages/participant/Fallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import Personality from "@/pages/admin/Personality";
import PurposePage from "@/pages/admin/PurposePage";
import Corpus from "@/pages/admin/Corpus";
import Guardrails from "@/pages/admin/Guardrails";
import Connections from "@/pages/admin/Connections";
import Evaluation from "@/pages/admin/Evaluation";
import Labs from "@/pages/admin/Labs";
import { RequireAdmin } from "@/components/RequireAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Entry />} />
          <Route path="/l/:slug" element={<Consent />} />
          <Route path="/session" element={<Session />} />
          <Route path="/fallback/:kind" element={<Fallback />} />
          <Route path="/auditions" element={<Auditions />} />
          <Route path="/mockups" element={<MockupIndex />} />
          <Route path="/mockups/notes" element={<MockupNotes />} />
          <Route path="/app" element={<Navigate to="/" replace />} />
          <Route path="/app/session" element={<Navigate to="/session" replace />} />
          <Route path="/app/fallback/:kind" element={<Fallback />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<Dashboard />} />
            <Route path="purpose" element={<PurposePage />} />
            <Route path="personality" element={<Personality />} />
            <Route path="corpus" element={<Corpus />} />
            <Route path="guardrails" element={<Guardrails />} />
            <Route path="connections" element={<Connections />} />
            <Route path="evaluation" element={<Evaluation />} />
            <Route path="labs" element={<Labs />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
